import Vue from 'vue';
import AddBlogEntry from './App.vue';
import Buefy from 'buefy';

Vue.use(Buefy,{
    defaultIconPack: 'fas',
})

if(document.getElementById("blogEntryFormStaffApp")){
    new Vue({
        render: h=>h(
            AddBlogEntry, {
                props:{
                    sectionListCreate: document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("section-list-create"),
                    entryListCreate: document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("entry-list-create"),
                    edit: document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("edit"),
                    entryEdit: document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("entry-edit"),
                    productSearch: document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("product-list-endpoint"),
                    taggedProdListUrl: document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("tagged-list-endpoint"),
                    tagCreate: document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("tag-create"),
                    tagRemove: document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("tag-remove"),
                    blogListView:document.getElementById("blogEntryFormStaffApp")
                        .getAttribute("entry-list-view")
                }
            }
        )
    }).$mount("#blogEntryFormStaffApp")
}
